import {
  App,
  type RouteCacheEntry,
  type RouteTextureConfig,
  type RouteSelectorConfig,
} from "@app/context";

interface PkgGpuConfig {
  textures?: Record<string, RouteTextureConfig>;
  selectors?: Record<string, RouteSelectorConfig>;
}

export interface PkgPayload {
  routes?: Record<string, string>;
  cache?: Record<string, RouteCacheEntry>;
  gpu?: PkgGpuConfig;
}

const AK_URL = "/ak.json";

export async function loadPkg(): Promise<PkgPayload> {
  let pkg: PkgPayload | null = null;

  const inlineScript = document.getElementById("__AK__");
  if (inlineScript?.textContent) {
    try {
      pkg = JSON.parse(inlineScript.textContent) as PkgPayload;
    } catch {}
  }

  if (!pkg) {
    const response = await fetch(AK_URL, { cache: "no-store" });
    if (!response.ok) {
      throw new Error("ak.json not found; run build/dev once.");
    }
    pkg = (await response.json()) as PkgPayload;
  }

  App.config.routes = (pkg.routes || Object.create(null)) as Record<
    string,
    string
  >;
  App.cache = (pkg.cache || Object.create(null)) as Record<
    string,
    RouteCacheEntry
  >;
  if (pkg.gpu?.textures) {
    App.data.gpu.textures = {
      ...(App.data.gpu.textures || {}),
      ...pkg.gpu.textures,
    };
  }
  if (pkg.gpu?.selectors) {
    App.data.gpu.selectors = {
      ...(App.data.gpu.selectors || {}),
      ...pkg.gpu.selectors,
    };
  }
  return pkg;
}

export function getFromCache(url: string): RouteCacheEntry | null {
  const normalized = url !== "/" ? url.replace(/\/$/, "") : "/";
  return App.cache[normalized] || null;
}
